/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Section_KnowledgeInputs */

const en_directory_detail_section_knowledge = /** @type {(inputs: Directory_Detail_Section_KnowledgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Knowledge base`)
};

const zh_directory_detail_section_knowledge = /** @type {(inputs: Directory_Detail_Section_KnowledgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`知识库`)
};

/**
* | output |
* | --- |
* | "Knowledge base" |
*
* @param {Directory_Detail_Section_KnowledgeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_section_knowledge = /** @type {((inputs?: Directory_Detail_Section_KnowledgeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Section_KnowledgeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_section_knowledge(inputs)
	return zh_directory_detail_section_knowledge(inputs)
});
export { directory_detail_section_knowledge as "directory.detail.section.knowledge" }